// Module
var code = "<div class=\"scannerSpacer\">\n    <div class=\"top\"></div>\n    <div class=\"left\"></div>\n    <div class=\"scannerRoot\" data-ng-class=\"{'camera-visible': cameraVisible}\"></div>\n    <div class=\"right\"></div>\n    <div class=\"bottom\"></div>\n</div>\n";
// Exports
module.exports = code;